export const parseNumber = (value: string) => Number(value.replace(/,/g, '')) || 0;
